import * as RadixTabs from '@radix-ui/react-tabs';
import * as React from 'react';
import type { TabConfig } from '../../../interfaces/globals.interface';
import './simple-tabs.scss';

type SimpleTabsProps = {
  ariaLabel: string;
  tabs: TabConfig[];
  tabsGroupName: string;
  parentComponent?: string;
  defaultSlug?: string;
  orientation?: 'horizontal' | 'vertical';
};

export default function SimpleTabs(props: SimpleTabsProps): React.ReactElement {
  const {
    ariaLabel,
    tabs,
    tabsGroupName,
    parentComponent,
    defaultSlug,
    orientation = 'horizontal',
  } = props;

  const initialIndex = React.useMemo(() => {
    if (defaultSlug) {
      const idx = tabs.findIndex((t) => t.slug === defaultSlug);
      if (idx >= 0) return idx;
    }
    return 0;
  }, [defaultSlug, tabs]);

  return (
    <RadixTabs.Root
      defaultValue={`${tabsGroupName}-${initialIndex}`}
      orientation={orientation}
      className={`SimpleTabs__Root SimpleTabs__Root--${orientation}`}
      id={parentComponent ? `simple-tabs-${parentComponent}` : undefined}
    >
      <RadixTabs.List
        aria-label={ariaLabel}
        className={`SimpleTabs__List SimpleTabs__List--${orientation}`}
        id={
          parentComponent
            ? `simple-tabs-${parentComponent}-tabs-wrapper`
            : undefined
        }
      >
        {tabs.map((tab, index) => (
          <RadixTabs.Trigger
            key={index}
            value={`${tabsGroupName}-${index}`}
            className="SimpleTabs__Trigger"
          >
            {tab.label}
          </RadixTabs.Trigger>
        ))}
      </RadixTabs.List>
      {tabs.map((tab, index) => (
        <RadixTabs.Content
          key={index}
          value={`${tabsGroupName}-${index}`}
          className="CUSTOM__TABS__TAB__PANEL"
        >
          {tab.child}
        </RadixTabs.Content>
      ))}
    </RadixTabs.Root>
  );
}
